import ApiClient from "Store/client";

export const loginApi = (body) => ApiClient<LoginResponse>(`api/login`, { method: "POST", body });

export const fetchCurrentUserApi = () => ApiClient(`api/users`);

export const LogoutApi = () => ApiClient(`api/logout`, { method: "POST" });

export const updateInstructorAvatarApi = (body: FormData) =>
  ApiClient(`api/commands/update-instructor-avatar`, {
    method: "POST",
    body,
    type: "form-data"
  });

export const changePasswordApi = (body) =>
  ApiClient(`api/reset-password/change`, { method: "POST", body });

export const resetPasswordApi = (body) => ApiClient(`api/reset-password`, { method: "POST", body });

export const impersonateApi = (userId: string) =>
  ApiClient(`api/impersonate/${userId}`, { method: "POST" });

export const updateLastVersionSeenApi = (body) =>
  ApiClient(`api/commands/update-instructor-last-version-seen`, {
    method: "PATCH",
    body
  });
